import {ChangeDetectionStrategy, Component} from '@angular/core';
import {StatCardComponent} from '@app/my-account/dashboard/stat-card/stat-card.component';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {CheckoutsSelectors} from '@store/checkouts/checkouts.selectors';
import {LibraryCardComponent} from '@lib/components/library-card/library-card.component';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {RecentNotificationsComponent} from '@app/my-account/dashboard/recent-notifications/recent-notifications.component';
import {RecentBorrowingHistoryComponent} from '@app/my-account/dashboard/recent-borrowing-history/recent-borrowing-history.component';

@Component({
  selector: 'px-dashboard',
  host: {
    class: 'flex flex-col gap-y-5 w-full'
  },
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatCardComponent, SelectPipe, LibraryCardComponent, RecentNotificationsComponent, RecentBorrowingHistoryComponent]
})
export class DashboardComponent {

  public readonly patronSelectors = PatronSelectors.Auth;
  public readonly accountStatusSelectors = PatronSelectors.AccountStatus;
  public readonly readyForPickupSelectors = HoldsSelectors.ReadyForPickup;
  public readonly nextCheckedOutDueDateSelectors = CheckoutsSelectors.NextCheckedOutDueDate;
  public readonly viewportSelectors = ViewportSelectors;
}
